import * as React from "react";
import {
  List,
  TextField,
  SearchInput,
  EditButton,
  BooleanField,
  BooleanInput,
  ReferenceField,
  SelectInput,
  SelectArrayInput,
  ReferenceArrayInput,
  usePermissions,
  DataTable,
} from "react-admin";
import { useNavigate } from "react-router-dom";

import { ROLE_TYPES } from "../enums/Roles";
import { RESTAURANT_TYPES } from "../enums/RestaurantTypes";

const RestaurantFilter = () => [
  <SearchInput source="name" alwaysOn />,
  <SelectInput
    optionText="name"
    choices={[
      { id: RESTAURANT_TYPES.REGULAR, name: "Regular" },
      { id: RESTAURANT_TYPES.GUIDE, name: "Guía" },
      { id: RESTAURANT_TYPES.PREGUIDE, name: "Pre-Guía" },
      { id: RESTAURANT_TYPES.ALL, name: "Todos" },
    ]}
    label="Tipo"
    source="type"
    alwaysOn
  />,

  <ReferenceArrayInput
    source="placeTypes"
    reference="place-types"
    perPage={100}
    label="Tipos de Lugar"
  >
    <SelectArrayInput optionText="name" label="Tipos de Lugar" />
  </ReferenceArrayInput>,
  <ReferenceArrayInput
    source="placeTargets"
    reference="place-targets"
    perPage={100}
    label="Targets del Lugar"
  >
    <SelectArrayInput optionText="name" label="Targets del Lugar" />
  </ReferenceArrayInput>,

  <ReferenceArrayInput
    source="districts"
    reference="districts"
    perPage={1000}
    sort={{ field: "name", order: "ASC" }}
    label="Barrios"
  >
    <SelectArrayInput optionText="name" label="Barrios" />
  </ReferenceArrayInput>,
  <ReferenceArrayInput
    source="region"
    reference="regions"
    perPage={100}
    sort={{ field: "name", order: "ASC" }}
    label="Regiones"
  >
    <SelectArrayInput optionText="name" label="Regiones" />
  </ReferenceArrayInput>,
  <BooleanInput label="QR Generado" source="qr" />,
  <BooleanInput label="Asociado a MP" source="linkedToMercadoPago" />,
  <BooleanInput label="Facturación Cargada" source="billingData" />,
  <BooleanInput label="Activo" source="active" />,
  <BooleanInput label="En onboarding" source="isOnboarding" />,
];

const RestaurantList = () => {
  const { permissions } = usePermissions();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (permissions === ROLE_TYPES.RESTAURANT_DRAFT) {
      const restaurant = JSON.parse(localStorage.getItem("restaurant") ?? "{}");
      navigate(`/restaurants/${restaurant.id}/show`);
    }
  }, [permissions, navigate]);

  return (
    <List
      title={permissions === ROLE_TYPES.ADMIN ? "Restaurantes" : "Mi Local"}
      filters={permissions === ROLE_TYPES.ADMIN && RestaurantFilter()}
      filterDefaultValues={{ type: "ALL" }}
      exporter={permissions !== ROLE_TYPES.ADMIN ? false : undefined}
      pagination={permissions !== ROLE_TYPES.ADMIN ? false : undefined}
    >
      <DataTable bulkActionButtons={false} rowClick="show">
        <DataTable.Col source="name" label="Nombre" />
        <DataTable.Col source="address" label="Dirección" />
        <DataTable.Col source="district" label="Barrio">
          <ReferenceField
            source="district"
            reference="districts"
            link={false}
            label="Barrio"
          >
            <TextField source="name" />
          </ReferenceField>
        </DataTable.Col>
        {permissions === ROLE_TYPES.ADMIN && (
          <DataTable.Col source="type" label="Tipo">
            <TextField source="type" label="Tipo" />
          </DataTable.Col>
        )}
        <DataTable.Col source="qr" label="QR Generado">
          <BooleanField source="qr" label="QR Generado" looseValue />
        </DataTable.Col>
        <DataTable.Col source="linkedToMercadoPago" label="Asociado a MP">
          <BooleanField
            source="linkedToMercadoPago"
            label="Asociado a MP"
            looseValue
          />
        </DataTable.Col>
        <DataTable.Col source="active" label="Activo">
          <BooleanField source="active" label="Activo" />
        </DataTable.Col>
        {permissions === ROLE_TYPES.ADMIN && (
          <DataTable.Col source="isOnboarding" label="En onboarding">
            <BooleanField source="isOnboarding" label="En onboarding" />
          </DataTable.Col>
        )}
        <DataTable.Col>
          <EditButton />
        </DataTable.Col>
      </DataTable>
    </List>
  );
};
export { RestaurantList };
